export default __webpack_public_path__ + "static/media/checkers-4-rMIN.0c5c77ec.jpg";